//const StatCard = ({ item, handleClick, colClass }) => {
//    return (
//        <div className={`${colClass} mb-3 `}>
//            <div
//                className="stat-card"
//                onClick={() => handleClick(item)}
//            >
//                <div
//                    className="stat-card-header"
//                    style={{ background: item.cardColor }}
//                >
//                    {item.name}
//                </div>

//                <div className="stat-card-body">

//                    <span className="stat-value">
//                        {item.value}
//                    </span>

//                    <div
//                        className="stat-icon"
//                        style={{ background: item.cardColor }}
//                    >
//                        <i className={item.icon}></i>
//                    </div>

//                </div>
//            </div>
//        </div>
//    );
//};

//export default StatCard;

const StatCard = ({ item, handleClick, colClass = "col-md-3" }) => {
    return (
        <div className={`${colClass} mb-3`}>
            <div
                className="card h-100 border-0"
                style={{
                    cursor: "pointer", borderRadius: "12px", background: `linear-gradient(135deg, ${item.cardColor}22 0%, ${item.cardColor}11 100%)`, borderLeft: `4px solid ${item.cardColor}`, boxShadow: `0 4px 15px ${item.cardColor}33`,
                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                }}
                onClick={() => handleClick(item)}
                onMouseEnter={e => {
                    e.currentTarget.style.transform = "translateY(-3px)";
                    e.currentTarget.style.boxShadow = `0 8px 25px ${item.cardColor}55`;
                }}
                onMouseLeave={e => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = `0 4px 15px ${item.cardColor}33`;
                }}
            >
                <div className="card-body py-2 px-2">
                    <div className="d-flex justify-content-between align-items-center">

                       
                        <div
                            style={{  backgroundColor: item.cardColor,   height: "46px",  width: "46px",   borderRadius: "10px",  display: "flex", alignItems: "center", justifyContent: "center",
                                flexShrink: 0,
                            }}
                        >
                            <i  className={item.icon}  style={{ color: "#fff", fontSize: "16px" }}   ></i>
                        </div>

                     
                        <div className="text-end ms-2">
                            <div
                                style={{  fontSize: "11px", fontWeight: "600",  color: "#888", textTransform: "uppercase", letterSpacing: "0.5px",  marginBottom: "2px",  }} >
                                {item.name}
                            </div>
                            <div  style={{  fontSize: "22px",  fontWeight: "700",  color: item.cardColor,  lineHeight: "1", }}  >
                                {item.value}
                            </div>
                        </div>

                    </div>

                  
                    <div style={{  marginTop: "10px",  height: "3px",  borderRadius: "2px",  background: `linear-gradient(90deg, ${item.cardColor}, ${item.cardColor}44)`, opacity: 0.6,  }} />
                </div>
            </div>
        </div>
    );
};

export default StatCard;